import { render, staticRenderFns } from "./CmsConsole.vue?vue&type=template&id=97d725d6&scoped=true&"
import script from "./CmsConsole.vue?vue&type=script&lang=js&"
export * from "./CmsConsole.vue?vue&type=script&lang=js&"
import style0 from "./CmsConsole.vue?vue&type=style&index=0&id=97d725d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d725d6",
  null
  
)

export default component.exports